import { apiSlice } from "../../api/ApiService";
const updateAdminUserApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateAdminUser: builder.mutation({
      query: ({body, accessToken}) => ({
        url: `/api/v1/Administration/admin-user`,
        method: "PUT",
        data: body,
          headers: {
          accept: "*/*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }),
      invalidatesTags: (result, error) => [
        { type: "AdminList" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateAdminUserMutation } = updateAdminUserApi;
export default updateAdminUserApi;


